export default class Course {
}
